import {
  BsFillPersonLinesFill,
  BsDatabaseAdd,
} from "react-icons/bs";
import { MdOutlinePeopleAlt, MdOutlineFoodBank } from "react-icons/md";
import { HiArrowCircleDown, HiDocumentDuplicate } from "react-icons/hi";
import { BiRfid } from "react-icons/bi";
import { FaBoxesPacking } from "react-icons/fa6";
import { TbCubeSend } from "react-icons/tb";
import { IoDocumentsOutline } from "react-icons/io5";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { GrDocumentUser } from "react-icons/gr";
import { LiaMapSignsSolid, LiaPersonBoothSolid } from "react-icons/lia";
import { AiOutlineApartment } from "react-icons/ai";
import { GoStack } from "react-icons/go";
import { PiShoppingBagOpen } from "react-icons/pi";
import { RiErrorWarningFill } from "react-icons/ri";

export const SidebarData = [
  {
    title: "Master",
    icon: BsDatabaseAdd,
    arrow: <HiArrowCircleDown />,
    link: null,
    role: ["Admin"],
    childrens: [
      {
        title: "Users",
        icon: <MdOutlinePeopleAlt />,
        link: "/master/users",
        roles: ["Admin"],
      },
      {
        title: "Karyawan",
        icon: <BsFillPersonLinesFill />,
        link: "/master/karyawan",
        roles: ["Admin"],
      },
      {
        title: "Vendor",
        icon: <MdOutlineFoodBank />,
        link: "/master/vendor",
        roles: ["Admin"],
      },
      {
        title: "Departemen",
        icon: <AiOutlineApartment />,
        link: "/master/departemen",
        roles: ["Admin"],
      },
      {
        title: "Lokasi",
        icon: <LiaMapSignsSolid />,
        link: "/master/lokasi",
        roles: ["Admin"],
      },
    ],
  },
  {
    title: "Input Qty Porsi",
    icon: FaBoxesPacking,
    arrow: <HiArrowCircleDown />,
    link: "/input_qty_porsi",
    role: ["Vendor", "Admin"],
  },
  {
    title: "Tapping Makanan",
    icon: BiRfid,
    arrow: <MdOutlineFoodBank />,
    link: "/tapping_makanan",
    role: ["Vendor"],
  },
  {
    title: "Tapping Monitor",
    icon: BiRfid,
    arrow: <MdOutlineFoodBank />,
    link: "/tapping_admin",
    role: ["Admin"],
  },
  {
    title: "Drop Off Input",
    icon: TbCubeSend,
    arrow: <HiArrowCircleDown />,
    link: "/drop_off_input",
    role: ["Vendor"],
  },
  {
    title: "Drop Off ACC",
    icon: TbCubeSend,
    arrow: <HiArrowCircleDown />,
    link: "/drop_off_acc",
    role: ["Admin"],
  },
  {
    title: "Guest Serving",
    icon: LiaPersonBoothSolid,
    arrow: <HiArrowCircleDown />,
    link: "/guest_serving",
    role: ["Vendor"],
  },
  {
    title: "Report",
    icon: IoDocumentsOutline,
    arrow: <HiArrowCircleDown />,
    link: null,
    role: ["Admin"],
    childrens: [
      {
        title: "Report Tapping Makanan",
        icon: <HiOutlineDocumentCheck />,
        link: "/report/tapping_makanan",
        roles: ["Admin"],
      },
      {
        title: "Report Longshift",
        icon: <HiDocumentDuplicate />,
        link: "/report/longshift",
        roles: ["Admin"],
      },
      {
        title: "Report Drop Off",
        icon: <GrDocumentUser />,
        link: "/report/drop_off",
        roles: ["Admin"],
      },
      {
        title: "Report Actual Porsi",
        icon: <GoStack />,
        link: "/report/actual_porsi",
        roles: ["Admin"],
      },
      {
        title: "Report Guest Serving",
        icon: <PiShoppingBagOpen />,
        link: "/report/guest_serving",
        roles: ["Admin"],
      },
      {
        title: "Report Error Logs",
        icon: <RiErrorWarningFill />,
        link: "/report/logs",
        roles: ["Admin"],
      },
    ],
  },
];
